/**
 * @file
 * theme behaviors.
 */

import {initMobileNav} from "./components/MobileNav/default";
import {initScrollAnimation} from "./components/ScrollAnimation/default";
import {initSwiper} from "./components/Swiper/default";
import {initPricingWidget} from "./components/PricingWidget/default";


(function (Drupal) {

    'use strict';

    Drupal.behaviors.jogakolin = {
        attach (context, settings) {

            /**
             * @return {void}
             */
            function initBaseComponents() {
                initMobileNav();
                initScrollAnimation();
                initSwiper();
                initPricingWidget();

            }

            /**
             * @return {void}
             */
            function reinitBaseComponents() {
            }

            window.reinitBaseComponents = reinitBaseComponents;
            window.initBaseComponents = initBaseComponents;

            initBaseComponents();
            reinitBaseComponents();
        }
    };

} (Drupal));

/* Variables. */


